// 🔁 Gerekli kütüphaneler
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Layout from "../../component/Layout";
import api from "../../axios";
import {
  PlusIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";

const SoftwarePackages = () => {
  const [softwares, setSoftwares] = useState([]);
  const [packages, setPackages] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [showAddSoftwareModal, setShowAddSoftwareModal] = useState(false);
  const [showEditSoftwareModal, setShowEditSoftwareModal] = useState(false);
  const [showAddPackageModal, setShowAddPackageModal] = useState(false);
  const [showEditPackageModal, setShowEditPackageModal] = useState(false);
  const [newSoftware, setNewSoftware] = useState({
    name: "",
    description: "",
    imageUrl: "",
    anaEkrandaGoster: false,
  });
  const [editSoftware, setEditSoftware] = useState(null);
  const [newPackage, setNewPackage] = useState({
    name: "",
    description: "",
    softwareId: "",
    price: 0,
    isActive: true
  });
  const [editPackage, setEditPackage] = useState(null);
  const [selectedSoftwareId, setSelectedSoftwareId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
    if (!isAdmin) {
      navigate('/dashboard');
      return;
    }
    const fetchData = async () => {
      try {
        const [softwaresRes, packagesRes, licensesRes] = await Promise.all([
          api.get("/api/software"),
          api.get("/api/package"),
          api.get("/api/license"),
        ]);
        setSoftwares(softwaresRes.data);
        setPackages(packagesRes.data);
        setLicenses(licensesRes.data);
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      }
    };

    fetchData();
  }, [navigate]);

  const handleAddSoftware = async () => {
    try {
      await api.post("/api/software", newSoftware);
      setShowAddSoftwareModal(false);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("Yazılım eklenirken hata oluştu.");
    }
  };

  const handleEditSoftware = async () => {
    try {
      await api.put(`/api/software/${editSoftware.id}`, editSoftware);
      setShowEditSoftwareModal(false);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("Yazılım güncellenirken hata oluştu.");
    }
  };

  const handleDeleteSoftware = async (softwareId) => {
    try {
      const relatedPackages = packages.filter((p) => p.softwareId === softwareId);
      for (const pkg of relatedPackages) {
        await api.delete(`/api/package/${pkg.id}`);
      }
      await api.delete(`/api/software/${softwareId}`);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("Silme işlemi sırasında hata oluştu.");
    }
  };

  const handleAddPackage = async () => {
    try {
      await api.post("/api/package", { ...newPackage, softwareId: selectedSoftwareId });
      setShowAddPackageModal(false);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("Paket eklenirken hata oluştu.");
    }
  };
  const handleEditPackage = async () => {
    try {
      await api.put(`/api/package/${editPackage.id}`, editPackage);
      setShowEditPackageModal(false);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("Paket güncellenirken hata oluştu.");
    }
  };

  const handleDeletePackage = async (packageId) => {
    try {
      await api.delete(`/api/package/${packageId}`);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("Paket silinirken hata oluştu.");
    }
  };
  const getUserCount = (softwareId, packageId = null) => {
    if (packageId) {
      return licenses.filter((l) => l.packageId === packageId).length;
    }
    return licenses.filter((l) => l.softwareId === softwareId).length;
  };

  return (
    <div>
      <Helmet>
        <title>Yazılımlar ve Paketler</title>
      </Helmet>
      <Layout pageTitle="Yazılımlar ve Paketler">
      <div className="p-4 sm:p-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
            <h2 className="text-xl sm:text-2xl font-semibold">Yazılımlar ve Paketler</h2>
            <button
              className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded"
              onClick={() => setShowAddSoftwareModal(true)}
            >
              Yeni Yazılım Ekle
            </button>
          </div>

          <div className="overflow-x-auto w-full bg-white rounded-lg shadow">
            <table className="min-w-full divide-y divide-gray-200 text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-3 text-left font-medium text-gray-600">#</th>
                  <th className="px-4 py-3 text-left font-medium text-gray-600">Yazılım</th>
                  <th className="px-4 py-3 text-left font-medium text-gray-600">Açıklama</th>
                  <th className="px-4 py-3 text-left font-medium text-gray-600">Kullanıcı</th>
                  <th className="px-4 py-3 text-left font-medium text-gray-600">İşlemler</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {softwares.map((software) => (
                  <>
                    <tr key={software.id}>
                      
                      <td className="px-4 py-4 text-gray-400 text-xs">ID: {software.id}</td>
                      <td className="px-4 py-4 font-semibold">{software.name}</td>
                      <td className="px-4 py-4">{software.description}</td>
                      <td className="px-4 py-4">{getUserCount(software.id)}</td>
                      <td className="px-4 py-4 flex gap-2 flex-wrap">
                        <button
                          className="bg-green-500 hover:bg-green-600 text-white p-2 rounded"
                          title="Paket Ekle"
                          onClick={() => {
                            setSelectedSoftwareId(software.id);
                            setNewPackage({ name: "", description: "", softwareId: software.id });
                            setShowAddPackageModal(true);
                          }}
                        >
                          <PlusIcon className="h-4 w-4" />
                        </button>
                        <button
                          className="bg-yellow-400 hover:bg-yellow-500 text-white p-2 rounded"
                          title="Düzenle"
                          onClick={() => {
                            setEditSoftware(software);
                            setShowEditSoftwareModal(true);
                          }}
                        >
                          <PencilSquareIcon className="h-4 w-4" />
                        </button>
                        <button
                          className="bg-red-500 hover:bg-red-600 text-white p-2 rounded"
                          title="Sil"
                          onClick={() => {
                            if (window.confirm(`"${software.name}" silinsin mi? Tüm paketleri de silinecek.`)) {
                              handleDeleteSoftware(software.id);
                            }
                          }}
                        >
                          <TrashIcon className="h-4 w-4" />
                        </button>
                      </td>
                    </tr>

                    {packages
                      .filter((p) => p.softwareId === software.id)
                      .map((pkg) => (
                        <tr key={`package-${pkg.id}`} className="bg-gray-50">
                          <td className="px-8 py-4 text-xs">↳ {pkg.name} <span className="text-gray-400 text-[10px]">#{pkg.id}</span></td>
                          <td className="px-4 py-4 text-xs"></td>
                          <td className="px-4 py-4 text-xs">{pkg.description}</td>
                          <td className="px-4 py-4 text-xs">{getUserCount(software.id, pkg.id)}</td>
                          <td className="px-4 py-4 flex gap-2 text-xs">
                            <button
                              className="bg-yellow-400 hover:bg-yellow-500 text-white p-1 rounded"
                              title="Paket Düzenle"
                              onClick={() => {
                                setEditPackage(pkg);
                                setShowEditPackageModal(true);
                              }}
                            >
                              <PencilSquareIcon className="h-4 w-4" />
                            </button>
                            <button
                              className="bg-red-500 hover:bg-red-600 text-white p-1 rounded"
                              title="Paket Sil"
                              onClick={() => {
                                if (window.confirm(`Paket \"${pkg.name}\" silinsin mi?`)) {
                                  handleDeletePackage(pkg.id);
                                }
                              }}
                            >
                              <TrashIcon className="h-4 w-4" />
                            </button>
                          </td>
                        </tr>
                      ))}
                  </>
                ))}
              </tbody>
            </table>
          </div>

          {/* Yazılım Ekle Modalı */}
          {showAddSoftwareModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white p-6 rounded shadow-lg w-full max-w-md max-h-screen overflow-y-auto">
                <h3 className="text-xl font-semibold mb-4">Yeni Yazılım Ekle</h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Yazılım Adı</label>
                    <input
                      type="text"
                      value={newSoftware.name}
                      onChange={(e) => setNewSoftware({ ...newSoftware, name: e.target.value })}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Açıklama</label>
                    <textarea
                      value={newSoftware.description}
                      onChange={(e) => setNewSoftware({ ...newSoftware, description: e.target.value })}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Resim URL</label>
                    <input
                      type="text"
                      value={newSoftware.imageUrl}
                      onChange={(e) => setNewSoftware({ ...newSoftware, imageUrl: e.target.value })}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={newSoftware.anaEkrandaGoster}
                      onChange={(e) => setNewSoftware({ ...newSoftware, anaEkrandaGoster: e.target.checked })}
                      className="w-4 h-4"
                    />
                    <label className="text-sm">Ana ekranda göster</label>
                  </div>
                </div>
                <div className="flex justify-end space-x-4 mt-6">
                  <button
                    className="bg-gray-400 hover:bg-gray-500 text-white py-2 px-4 rounded"
                    onClick={() => setShowAddSoftwareModal(false)}
                  >
                    İptal
                  </button>
                  <button
                    className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded"
                    onClick={handleAddSoftware}
                  >
                    Kaydet
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Paket Ekle Modalı */}
          {showAddPackageModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white p-6 rounded shadow-lg w-full max-w-md max-h-screen overflow-y-auto">
                <h3 className="text-xl font-semibold mb-4">Yeni Paket Ekle</h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Paket Adı</label>
                    <input
                      type="text"
                      value={newPackage.name}
                      onChange={(e) => setNewPackage({ ...newPackage, name: e.target.value })}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Açıklama</label>
                    <textarea
                      value={newPackage.description}
                      onChange={(e) => setNewPackage({ ...newPackage, description: e.target.value })}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Fiyat</label>
                    <input
                      type="number"
                      value={newPackage.price}
                      onChange={(e) => setNewPackage({ ...newPackage, price: e.target.value })}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={newPackage.isActive}
                      onChange={(e) => setNewPackage({ ...newPackage, isActive: e.target.checked })}
                      className="w-4 h-4"
                    />
                    <label className="text-sm">Aktif</label>
                  </div>
                </div>
                <div className="flex justify-end space-x-4 mt-6">
                  <button
                    className="bg-gray-400 hover:bg-gray-500 text-white py-2 px-4 rounded"
                    onClick={() => setShowAddPackageModal(false)}
                  >
                    İptal
                  </button>
                  <button
                    className="bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded"
                    onClick={handleAddPackage}
                  >
                    Kaydet
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Yazılım Düzenleme Modalı */}
          {showEditSoftwareModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white p-6 rounded shadow-lg w-full max-w-md max-h-screen overflow-y-auto">
                <h3 className="text-xl font-semibold mb-4">Yazılımı Düzenle</h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Adı</label>
                    <input
                      type="text"
                      value={editSoftware?.name || ""}
                      onChange={(e) => setEditSoftware({ ...editSoftware, name: e.target.value })}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Açıklama</label>
                    <textarea
                      value={editSoftware?.description || ""}
                      onChange={(e) => setEditSoftware({ ...editSoftware, description: e.target.value })}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Resim URL</label>
                    <input
                      type="text"
                      value={editSoftware?.imageUrl || ""}
                      onChange={(e) => setEditSoftware({ ...editSoftware, imageUrl: e.target.value })}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id="editAnaEkrandaGoster"
                      checked={editSoftware?.anaEkrandaGoster || false}
                      onChange={(e) => setEditSoftware({ ...editSoftware, anaEkrandaGoster: e.target.checked })}
                      className="w-4 h-4"
                    />
                    <label htmlFor="editAnaEkrandaGoster" className="text-sm">Ana ekranda göster</label>
                  </div>
                </div>
                <div className="flex justify-end space-x-4 mt-6">
                  <button
                    className="bg-gray-400 hover:bg-gray-500 text-white py-2 px-4 rounded"
                    onClick={() => setShowEditSoftwareModal(false)}
                  >
                    İptal
                  </button>
                  <button
                    className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded"
                    onClick={handleEditSoftware}
                  >
                    Güncelle
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* Paket Düzenleme Modalı */}
          {showEditPackageModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white p-6 rounded shadow-lg w-full max-w-md max-h-screen overflow-y-auto">
              <h3 className="text-xl font-semibold mb-4">Paket Düzenle</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-1">Paket Adı</label>
                  <input
                    type="text"
                    value={editPackage?.name || ""}
                    onChange={(e) => setEditPackage({ ...editPackage, name: e.target.value })}
                    className="w-full p-2 border rounded"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Açıklama</label>
                  <textarea
                    value={editPackage?.description || ""}
                    onChange={(e) => setEditPackage({ ...editPackage, description: e.target.value })}
                    className="w-full p-2 border rounded"
                  />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Fiyat</label>
                    <input
                      type="number"
                      value={editPackage?.price || 0}
                      onChange={(e) => setEditPackage({ ...editPackage, price: parseFloat(e.target.value) })}
                      className="w-full p-2 border rounded"
                    />
                </div>
                <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id="editAktif"
                      checked={editPackage?.isActive || false}
                      onChange={(e) => setEditPackage({ ...editPackage, isActive: e.target.checked })}
                      className="w-4 h-4"
                    />
                    <label htmlFor="editAktif" className="text-sm">Aktif</label>
                  </div>
              </div>
              <div className="flex justify-end space-x-4 mt-6">
                <button
                  className="bg-gray-400 hover:bg-gray-500 text-white py-2 px-4 rounded"
                  onClick={() => setShowEditPackageModal(false)}
                >
                  İptal
                </button>
                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded"
                  onClick={handleEditPackage}
                >
                  Güncelle
                </button>
              </div>
            </div>
          </div>
        )}
        </div>
      </Layout>
    </div>
  );
};

export default SoftwarePackages;